<template>
  <div class="faq-content">
    <h2>Frequently Asked Questions</h2>
    <div v-for="(faq, index) in faqs" :key="index" class="faq-item">
      <div class="faq-question" @click="toggleAnswer(index)">
        <span class="toggle-symbol">
          {{ faq.showAnswer ? '-' : '+' }}
        </span>
        <span class="question-text">{{ faq.question }}</span>
      </div>
      <p v-if="faq.showAnswer" class="faq-answer">
        {{ faq.answer }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      faqs: [
        {
          question: 'What services does SWD Group offer?',
          answer:
            "SWD Group provides a comprehensive range of financial planning services, including wealth and income strategies, tax-mitigation planning, asset preservation, insurance and Medicare advice, and legacy planning. Their approach is holistic, addressing all aspects of clients' financial needs.",
          showAnswer: false,
        },
        {
          question: 'What is the focus of retirement planning at SWD Group?',
          answer:
            'Retirement planning at SWD Group emphasizes creating reliable income streams, minimizing investment fees and tax burdens, and simplifying the overall retirement process. They view retirement as a vibrant new beginning and aim to help clients enjoy it on their terms.',
          showAnswer: false,
        },
        {
          question: 'Are the advisors at SWD Group fiduciaries?',
          answer:
            'Yes, the advisors at SWD Group are fiduciaries, meaning they are committed to doing what is right for their clients rather than what is merely popular. This commitment ensures that clients receive unbiased advice tailored to their best interests.',
          showAnswer: false,
        },
        {
          question: 'How can I get started with retirement planning?',
          answer:
            'Interested individuals can begin their retirement planning journey by accessing free resources such as e-books provided by SWD Group. These resources include checklists for retirement planning and practical tips for enjoying retirement.',
          showAnswer: false,
        },
        {
          question: 'What is the importance of tax-mitigation planning?',
          answer:
            "Tax-mitigation planning is crucial for maximizing your wealth and ensuring that you keep more of your hard-earned money. SWD Group's advisors work to create strategies that minimize tax liabilities while complying with regulations, allowing clients to optimize their financial outcomes.",
          showAnswer: false,
        },
        {
          question: 'How does SWD Group ensure personalized financial guidance?',
          answer:
            "SWD Group emphasizes a personalized approach by understanding each client's unique financial situation and goals. Their advisors take the time to listen and tailor strategies that align with individual aspirations, ensuring that clients feel supported throughout their financial journey.",
          showAnswer: false,
        },
        {
          question: 'What types of insurance does SWD Group provide advice on?',
          answer:
            'SWD Group offers guidance on various types of insurance, including life insurance, long-term care insurance, and Medicare options. Their goal is to help clients choose the right coverage that fits their needs and protects their assets.',
          showAnswer: false,
        },
        {
          question: 'Can SWD Group assist with legacy planning?',
          answer:
            'Yes, legacy planning is one of the key services offered by SWD Group. They help clients create plans to ensure their wealth is passed on according to their wishes, which may include estate planning, trusts, and charitable giving strategies.',
          showAnswer: false,
        },
        {
          question: 'How often should I review my financial plan?',
          answer:
            'It is recommended to review your financial plan at least annually or whenever there are significant life changes, such as marriage, retirement, or the birth of a child. Regular reviews ensure that your financial strategies remain aligned with your goals and adapt to any changes in your circumstances.',
          showAnswer: false,
        },
      ],
    }
  },
  methods: {
    toggleAnswer(index) {
      this.faqs[index].showAnswer = !this.faqs[index].showAnswer
    },
  },
}
</script>

<style scoped>
.faq-content {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.faq-content h2 {
  color: #073763;
  font-size: 16px;
  font-weight: bold;
  background-color: #f0eaff;
  padding: 10px;
}
.faq-item {
  margin-bottom: 10px;
}
.faq-question {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 5px;
  border-radius: 5px;
}
.toggle-symbol {
  margin-right: 10px;
  font-weight: bold;
  color: #073763;
}
.faq-answer {
  padding: 20px;
  background-color: #f0eaff;
}
</style>
